__turbopack_context__.v({
  "clampedWidthWrapper": "sub-section-module-scss-module__GrbVvW__clampedWidthWrapper",
  "cta": "sub-section-module-scss-module__GrbVvW__cta",
  "description": "sub-section-module-scss-module__GrbVvW__description",
  "headerTitle": "sub-section-module-scss-module__GrbVvW__headerTitle",
  "title": "sub-section-module-scss-module__GrbVvW__title",
  "titleAndLinkWrapper": "sub-section-module-scss-module__GrbVvW__titleAndLinkWrapper",
  "wrapper": "sub-section-module-scss-module__GrbVvW__wrapper",
});
